<template>
	<div :class="['footerShell', { 'footerShell--home': homeLayout }]">
		<footer class="homeFooter">
			<div class="homeFooterContent">
				<div class="homeFooterContact">
					<div class="homeFooterHeading">联系我们</div>
					<div class="homeFooterCompany">杭州聚秀科技有限公司</div>
					<div class="homeFooterContactRow">
						<img src="@/assets/home-footer-location.png" alt="">
						<span>杭州市萧山区杭州湾信息港B1栋502室</span>
					</div>
					<div class="homeFooterContactRow">
						<img src="@/assets/home-footer-phone.png" alt="">
						<span>0571-82829806</span>
					</div>
					<a class="homeFooterContactRow" href="mailto:business@hzjuxiu.com">
						<img src="@/assets/home-footer-email.png" alt="">
						<span>business@hzjuxiu.com</span>
					</a>
					<div class="homeFooterQr">
						<img src="@/assets/home-footer-qr.png" alt="聚秀数智云二维码" loading="lazy">
						<div>聚秀数智云</div>
					</div>
				</div>
				<div class="homeFooterSolutions">
					<div class="homeFooterHeading">解决方案</div>
					<div class="homeFooterSolutionList">
						<router-link
							v-for="item in solutions"
							:key="item.path"
							:to="item.path"
							class="homeFooterSolution"
						>{{ item.name }}</router-link>
					</div>
				</div>
				<img class="homeFooterLogo" src="@/assets/home-footer-logo.png" alt="聚秀科技">
			</div>
			<a target="_blank" rel="noopener" href="https://beian.miit.gov.cn" class="homeFooterRecord">
				<img src="@/assets/guard.png" alt="">
				<span>浙ICP备17037851号</span>
			</a>
			<div class="homeFooterBottom">
				<div class="homeFooterDivider"></div>
			</div>
		</footer>
	</div>
</template>

<script>
export default {
	props: {
		homeLayout: {
			type: Boolean,
			default: false
		}
	},
	data(){
		return {
			solutions: [
				{ name: '智慧国资', path: '/stateOwnedAssets' },
				{ name: '智慧国企', path: '/stateOwnedEnterprise' },
				{ name: '资产云', path: '/assetCloud' },
				{ name: '智慧好管家', path: '/goodHousekeeper' },
				{ name: '智慧监管', path: '/intelligentSupervision' },
				{ name: '人工智能', path: '/ai' }
			]
		}
	}
}
</script>

<style lang="scss" scoped>
.footerShell{
	width: 100%;
	margin-bottom: 80px;
}
.footerShell--home{
	margin-bottom: 0;
	padding-bottom: calc(80px + var(--bottom));
	background: #0D1E33;
}
.homeFooter{
	box-sizing: border-box;
	width: 100%;
	height: 352px;
	padding: 44px 40px 26px;
	position: relative;
	background: #0D1E33;
	color: #FFFFFF;
	text-align: left;
	.homeFooterContent{
		display: grid;
		grid-template-columns: 330px 140px minmax(0, 1fr);
		column-gap: 42px;
	}
	.homeFooterLogo{
		display: block;
		width: 115px;
		height: 32px;
		justify-self: end;
	}
	.homeFooterHeading{
		font-size: 20px;
		font-weight: 600;
		color: #FFFFFF;
		line-height: 28px;
	}
	.homeFooterSolutionList{
		margin-top: 12px;
	}
	.homeFooterSolution{
		display: flex;
		align-items: center;
		height: 40px;
		font-size: 16px;
		font-weight: 400;
		color: #7D8998;
		line-height: 22px;
		text-decoration: none;
		white-space: nowrap;
	}
	.homeFooterCompany{
		margin-top: 12px;
		font-size: 16px;
		font-weight: 400;
		color: #7D8998;
		line-height: 22px;
	}
	.homeFooterContactRow{
		display: flex;
		align-items: center;
		margin-top: 8px;
		font-size: 16px;
		font-weight: 400;
		color: #7D8998;
		line-height: 22px;
		text-decoration: none;
		img{
			display: block;
			flex: none;
			width: 22px;
			height: 22px;
			margin-right: 10px;
			object-fit: contain;
		}
	}
	.homeFooterQr{
		display: flex;
		align-items: flex-end;
		margin-top: 16px;
		font-size: 16px;
		font-weight: 400;
		color: #7D8998;
		line-height: 22px;
		img{
			display: block;
			width: 96px;
			height: 96px;
			margin-right: 12px;
		}
	}
	.homeFooterBottom{
		position: absolute;
		left: 40px;
		right: 40px;
		bottom: 26px;
	}
	.homeFooterDivider{
		width: 100%;
		height: 1px;
		background: rgba(134, 142, 153, 0.4);
	}
	.homeFooterRecord{
		display: flex;
		align-items: center;
		position: absolute;
		right: 40px;
		bottom: 48px;
		font-size: 12px;
		color: #7D8998;
		line-height: 17px;
		text-decoration: none;
		img{
			display: block;
			width: 11px;
			height: 12px;
			margin-right: 8px;
		}
	}
}
</style>
